<template lang="html">
  <div class="DetailsUser ">
    <div v-if="user">
      <div class="hero is-small has-text-centered has-border-bottom">
        <div class="hero-body">
          <div class="has-text-grey-medium">
            <icon name="profile" scale="3" label="profile"></icon>
          </div>
          <h3 class="title is-size4 is-padded-small">{{ user.displayName }}</h3>
        </div>
      </div>
      <div class="is-pad-left-1">
        <cw-list-cell
          class="has-border-bottom"
          :title="user.email"
          subtitle="Email"
          :showDisclosureIndicator="false"
          :leftIconProps="{
            name: 'fa-envelope',
            bulmaIcon: true,
            scale: 1,
            colorClass: 'has-text-grey-light',
          }"
        />
        <cw-list-cell
          class="has-border-bottom"
          :title="user.phoneNumber"
          subtitle="Phone"
          :showDisclosureIndicator="false"
          :leftIconProps="{
            name: 'fa-phone',
            bulmaIcon: true,
            scale: 1,
            colorClass: 'has-text-grey-light',
          }"
        />

        <cw-basic-cell>
          <div slot="left-area">
            <span class="icon has-text-grey-light">
              <i class="las la-2x la-users"></i>
            </span>
          </div>
          <div slot="left-fill-area">
            <div>
              <cw-dropdown
                v-if="currentUser.uid !== user.uid"
                class="selection-dropdown anchored-bottom"
                :isActive.sync="roleEditing"
              >
                <div slot="trigger">
                  <p
                    class="button is-margin-top-05 is-black is-rounded is-outlined is-medium "
                  >
                    <span>{{
                      roleDisplay[user.customClaims.role || 'superintendent']
                    }}</span>
                    <span class="icon is-margin-left-1">
                      <i class="las la-2x la-angle-down"></i>
                    </span>
                  </p>
                </div>
                <ul
                  v-for="role in [
                    'baseUser',
                    'superintendent',
                    'accounting',
                    'admin',
                  ]"
                  :key="role"
                >
                  <li
                    class="dropdown-item is-size-5"
                    :class="{
                      'has-text-primary': role === user.customClaims.role,
                    }"
                    @click="roleSelected(role)"
                  >
                    {{ roleDisplay[role] }}
                  </li>
                </ul>
              </cw-dropdown>
              <p v-else class="is-size-5">
                {{ roleDisplay[user.customClaims.role || 'superintendent'] }}
              </p>
              <p class="is-size-5 has-text-grey-light">Role</p>
            </div>
          </div>
        </cw-basic-cell>
      </div>
      <div class="has-text-centered">
        <a
          v-if="currentUser.uid !== user.uid"
          class="button is-margin-top-1 is-primary is-rounded is-outlined is-medium"
          @click="deleteUser()"
        >
          <span class="icon is-small">
            <i class="las la-2x la-trash"></i>
          </span>
          <span>Delete User</span>
        </a>
        <a
          class="button is-margin-top-1 is-margin-left-1 is-black is-rounded is-outlined is-medium"
          @click="sendPasswordReset()"
        >
          <span class="icon is-small">
            <i class="las la-2x la-lock"></i>
          </span>
          <span>Reset Password</span>
        </a>
      </div>
    </div>
    <div v-else>
      No user
    </div>
  </div>
</template>

<script>
import authRequired from '@/components/mixins/auth-required';
import { RoleDisplay } from '@/enums/roles.js';
import { mapState } from 'vuex';
import axios from 'axios';
let apiHost = process.env.VUE_APP_API_HOST;

export default {
  name: 'DetailsUser',
  // share common functionality with component mixins
  mixins: [authRequired],
  props: {},
  // variables
  data() {
    return {
      roleEditing: false,
    };
  },
  beforeCreate() {
    let users = this.$store.state.user.users;
    if (!users || users.length < 1) {
      this.$store.dispatch('user/loadUsers');
    }
  },
  computed: {
    user() {
      let users = this.$store.state.user.users;
      if (users) {
        let user = users.find(u => {
          return this.$route.params.id === u.uid;
        });
        return user;
      } else {
        return null;
      }
    },
    ...mapState({
      currentUser: state => state.user.info,
    }),
    roleDisplay() {
      return RoleDisplay;
    },
  },
  components: {},
  methods: {
    async roleSelected(role) {
      this.roleEditing = false;

      if (role === this.user.customClaims.role) {
        return;
      }

      this.$modal.show('wifi-loader', { message: 'Processing...' });
      let email = this.user.email;
      let response = await this.$store.dispatch('user/updateUserRole', {
        email,
        role,
      });
      this.$modal.hide('wifi-loader');

      if (response.error) {
        let res = response.error.response;
        if (res && res.data) {
          this.$modal.show('alert', {
            title: res.data.title,
            message: res.data.message,
            type: 'warning',
          });
        }
      }
    },
    async deleteUser() {
      this.$modal.show('alert', {
        title: 'Delete User',
        message: `Are you sure you want to delete the account for ${this.user.displayName}?`,
        type: 'warning',
        actions: [
          {
            title: 'Delete User',
            classes: 'is-primary',
            callback: async () => {
              // Delete
              this.$modal.hide('alert');
              this.$modal.show('wifi-loader', { message: 'Processing...' });

              let uid = this.$route.params.id;
              let response = await this.$store.dispatch('user/deleteUser', {
                uid,
              });
              this.$modal.hide('wifi-loader');

              if (response.error) {
                let res = response.error.response;
                if (res && res.data) {
                  this.$modal.show('alert', {
                    title: res.data.title,
                    message: res.data.message,
                    type: 'warning',
                  });
                }
              } else {
                this.$modal.show('alert', {
                  title: 'Successfully Deleted Account',
                });
                this.$router.push({ path: `/users` });
              }
            },
          },
          {
            title: 'Cancel',
            classes: 'is-black',
          },
        ],
      });
    },
    async sendPasswordReset() {
      console.log('send reset');
      let email = this.user.email;
      if (!email) {
        this.$modal.show('alert', {
          title: 'Error sending Password Reset',
          message: 'No email could be found for this user account',
          type: 'warning',
        });
        console.log('unable to send reset');
        return;
      }

      this.$modal.show('wifi-loader', { message: 'Processing...' });

      try {
        let result = await axios.post(
          `${apiHost}/auth/request-password-reset`,
          {
            email,
          }
        );

        this.$modal.hide('wifi-loader');
        this.$modal.show('alert', result.data);
      } catch (err) {
        this.$modal.hide('wifi-loader');
        let res = err.response;
        if (res && res.data) {
          this.$modal.show('alert', {
            title: res.data.title,
            message: res.data.message,
            type: 'warning',
          });
        }
      }
    },
  },
  watch: {},
};
</script>

<style lang="stylus" scoped></style>
